import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import dashboardReducer from './slices/dashboard';
import productReducer from './slices/product';
import taxReducer from './slices/tax';
import nearpayTerminalReducer from './slices/nearpayTerminal';
import roleReducer from './slices/role';
import planReducer from './slices/plan';
import discountReducer from './slices/discount';
import categoryExpenseReducer from './slices/categoryExpense';
import uomReducer from './slices/uom';
import businessReducer from './slices/business';
import userReducer from './slices/user';
import attachmentReducer from './slices/attachment';
import exploreReducer from './slices/explore';
import projectReducer from './slices/project';
import distributorReducer from './slices/distributor';
import distributorCommissionReducer from './slices/distributorCommission';
import supportReducer from './slices/support';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  product: productReducer,
  tax: taxReducer,
  nearpayTerminal: nearpayTerminalReducer,
  role: roleReducer,
  user: userReducer,
  plan: planReducer,
  discount: discountReducer,
  categoryExpense: categoryExpenseReducer,
  uom: uomReducer,
  business: businessReducer,
  attachment: attachmentReducer,
  explore: exploreReducer,
  project: projectReducer,
  distributor: distributorReducer,
  distributorCommission: distributorCommissionReducer,
  support: supportReducer,
});

export { rootPersistConfig, rootReducer };
